import React from "react";
import "./chat-send.component.scoped.scss";
import { IconButton } from "@material-ui/core";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import { useTranslation } from "react-i18next";
interface ChatSendProps {
  onSend: () => void;
  disabled?: boolean;
  enabled?: boolean;
}

const ChatSend: React.FC<ChatSendProps> = ({
  onSend,
  disabled = false,
  enabled = false,
}) => {
  const { t } = useTranslation();
  const handleSendClick = () => {
    if (enabled && !disabled) {
      onSend();
    }
  };

  return (
    <IconButton
      className={`chat-send-button ${enabled ? "enabled" : "disabled"}`}
      onClick={handleSendClick}
      disabled={!enabled || disabled}
      size="small"
      title={t("CHATBOT.SEND")}
    >
      <SendOutlinedIcon />
    </IconButton>
  );
};

export default ChatSend;
